import script from "./Token.vue?vue&type=script&setup=true&lang=ts"
export * from "./Token.vue?vue&type=script&setup=true&lang=ts"

import "./Token.vue?vue&type=style&index=0&id=8a316dca&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a316dca"]])

export default __exports__